const OXYGENLISTSERVER = '_FFFFFFFFFFFFFF00001669740131169112_';
const HISTORYLISTSERVER = '_FFFFFFFFFFFFFF00001669841300039978_';

function createList(data, callback) {
  console.log("Got createList : ", data);
  if(data.ClientID && data.Type && data.Items) {
    let Client = window.botStore.getClientByID(data.ClientID); 
    if(Client) {
        let Context = JSON.parse(Client.CurrentContext);
        Context.HistoryIds = data.Items;
        Context.DisplayName= data.DisplayName || null;
        if(data.Type == 'History') {
            console.log("Call HistoyList");
            let params = {componentId : HISTORYLISTSERVER, containerId : null, command : 'createList', data : Context, Type : 'BotApi'}
            window.BotServices.callComponent(params, callback);
        } else {
            console.log("Call OxygenList");
            let params = {componentId : OXYGENLISTSERVER, containerId : null, command : 'createList', data : Context, Type : 'BotApi'}
            window.BotServices.callComponent(params, callback);
        }        
    } else {
        callback("No Client found");
    }
  } else {
    callback("Not valid params");
  }
}

function getListData(data, callback) {
    if(data.ClientID && data.Type) {
        let Client = window.botStore.getClientByID(data.ClientID);
        if(Client) {
            let Context = JSON.parse(Client.CurrentContext);
            if(data.Type == 'History') {
                console.log("Call HistoyList");
                let params = {componentId : HISTORYLISTSERVER, containerId : null, command : 'getListData', data : Context, Type : 'BotApi'}
                window.BotServices.callComponent(params, callback);
            }
        } else {
            callback("No Client found");
        }
    } else {
        callback("Not valid params");
    }
}

export {
  createList,
  getListData
}
